module.exports = __webpack_public_path__ + "static/media/Fondo-foto-Data-SEPSv2.ca9ba402.png";